import * as React from 'react';

import { FireScreenEventOnMount } from 'util/analytics/fire-screen-event';

import { ThemedLink } from 'view/common/themed-link';
import { useIntl } from 'react-intl-next';

import { Container, Title, IconContainer } from './styled';
import ErrorIcon from 'assets/images/error.react.svg';

import messages from './messages';

const LEARN_MORE_LINK =
    'https://support.atlassian.com/jira-service-management-cloud/docs/test-single-sign-on-for-customer-login/';

const CaSsoTestModeErrorPage = () => {
    const { formatMessage } = useIntl();

    return (
        <Container data-test-id="ca-sso-test-mode-error-screen-container">
            <FireScreenEventOnMount />
            <IconContainer>
                <ErrorIcon />
            </IconContainer>

            <Title>{formatMessage(messages.title)}</Title>
            <p>{formatMessage(messages.instructionMessage)}</p>
            <ThemedLink actionSubjectId="learnMoreSsoTestMode" href={LEARN_MORE_LINK} target="_blank">
                {formatMessage(messages.learnMoreLinkLabel)}
            </ThemedLink>
        </Container>
    );
};

export default CaSsoTestModeErrorPage;
